import { Injectable } from '@angular/core';
import { TempCreatRefApisModel } from '../../models/lawsuit/lawsuit';
import { TempCreatRefModel } from '../../view-models/lawsuit';
import { Mapper } from '../mapper';

@Injectable({
    providedIn: 'root'
})
export class CreateTempRefMapper implements Mapper<TempCreatRefApisModel, TempCreatRefModel>  {
    constructor(

    ) { }
    mapForm(param: TempCreatRefApisModel): TempCreatRefModel {
        return null!
    }

    mapTo(param: TempCreatRefModel): TempCreatRefApisModel {
        return {
            refCode: param.refCode,
            fdT_ID: param.fdTID,

        }
    }

} 